import { classNames } from 'libs/react';
import { Image } from 'components/Image';
import { Case } from 'components/util/Case';
import { Else } from 'components/util/Else';
import { When } from 'components/util/When';
import { React } from 'libs/react';
import './UserImage.scss';
/**
 * @component UserImage
 * @since 1.0.0
 */
export function UserImage(props) {
    var _a;
    const { style, user } = Object.assign({ style: 'normal' }, props);
    const className = classNames('user-image', 'user-image--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement(When, null,
            React.createElement(Case, { is: user.image },
                React.createElement(Image, { className: "user-image-image", source: (_a = user.image) === null || _a === void 0 ? void 0 : _a.url })),
            React.createElement(Else, null,
                React.createElement("div", { className: "user-image-letter" }, user.firstname[0])))));
}
